import { createApi } from '@reduxjs/toolkit/query/react'
import { customBaseQuery } from '../../shared/helpers'

const parseLabelData = (course) => {
  if (!course.labelData) return course

  return {
    ...course,
    labelData: typeof course.labelData === 'string'
      ? JSON.parse(course.labelData)
      : course.labelData,
  }
}

export const coursesApi = createApi({
  reducerPath: 'coursesApi',
  baseQuery: customBaseQuery, 
  endpoints: (build) => ({
    getCourses: build.query({
      query: (args) => ({
        urlKey: 'fetchDataUrl',
        params: args 
      }),
    
      serializeQueryArgs: ({ queryArgs }) => {
        return queryArgs.filters; 
      },
    
      transformResponse: (response) => {
        return {
          ...response,
          courses: response.courses.map(parseLabelData),
        }
      },

      merge: (currentCache, newResponse, { arg }) => {
        if (arg.page === 1) {
          return newResponse;
        }
      
        return {
          ...newResponse,
          courses: [
            ...(currentCache?.courses || []),
            ...newResponse.courses
          ]
        };
      },
    }),
    getComplianceStats: build.query({
      query: () => ({
        urlKey: 'fetchComplianceStatsUrl',
        params: {} 
      }),
      transformResponse: (response, meta, arg) => {
        return response.stats; 
      },
    }),
    getPossibleLocations: build.query({
      query: (args) => ({
        urlKey: 'fetchPossibleLocationsUrl',
        params: args
      }),
      transformResponse: (response) => {
        return response.location_list;
      },
    }),
    getCrsCourses: build.query({
      query: (args) => ({
        urlKey: 'fetchCrsCoursesUrl',
        params: args,
      }),
      transformResponse: (response) => {
        if(!response?.items?.length) {
          return []
        }

        return response.items.map((course) => {
          return { value: course.id, label: course.item}
        })
      }
    }),
    getCustomers: build.query({
      query: (args) => ({
        urlKey: 'fetchCustomersUrl',
        params: args,
      }),
      transformResponse: (response) => {
        if (!response?.items?.length) {
          return [];
        }
  
        return response.items.map((item) => ({
          value: item.id,
          label: item.item,
        }));
      }
    }),
    getCustomerCourses: build.query({
      query: (args) => ({
        urlKey: 'fetchCustomerCoursesUrl',
        params: args,
      }),
      transformResponse: (response) => {
        return response.map((course) => {
          return { value: course[0], label: course[1]}
        })
      }
    }),
    copyCustomerCourse: build.mutation({
      query: (args) => ({
        urlKey: 'copyCustomerCourseUrl',
        method: 'POST',
        params: args,
      }),
    }),
    renameCourse: build.mutation({
      query: ({url, newName}) => ({
        url: url,
        method: 'PUT',
        params: { name: newName },
      })
    }),
    moveToLeague: build.mutation({
      query: ({url, checked}) => ({
        url: url,
        method: 'POST',
        params: { checked: checked },
      })
    })
  }),
})

export const {
  useGetCoursesQuery,
  useGetComplianceStatsQuery,
  useGetPossibleLocationsQuery,
  useGetCrsCoursesQuery,
  useGetCustomersQuery,
  useGetCustomerCoursesQuery,
  useCopyCustomerCourseMutation,
  useRenameCourseMutation,
  useMoveToLeagueMutation,
} = coursesApi